export const STAFF_DOCUMENT_ACCEPT =
  ".jpg,.jpeg,.heic,.pdf,image/jpeg,image/heic,image/heif,application/pdf";

const ALLOWED_EXTENSIONS = new Set(["jpg", "jpeg", "heic", "pdf"]);

export function validateStaffDocumentFile(file) {
  if (!file) return "Please select a file.";

  const fileName = String(file.name || "");
  const extension = fileName.includes(".")
    ? fileName.split(".").pop().toLowerCase()
    : "";

  if (!ALLOWED_EXTENSIONS.has(extension)) {
    return "Invalid file type. Please upload a JPG, HEIC, or PDF file.";
  }

  return "";
}

export function isAllowedStaffDocumentFile(file) {
  return !validateStaffDocumentFile(file);
}
